import ENV from "./ENV";
import * as Clipboard from "expo-clipboard";

let clipboardHelpers = {
  copy(text) {
    if (ENV.WEB) {
      navigator.clipboard.writeText(text).then(() => {
        console.log("Async: Copying to clipboard was successful!");
      });
    } else {
      Clipboard.setStringAsync(text).then(() => {
        console.log("Async: Copying to clipboard was successful!");
      });
    }
  },
};

export default clipboardHelpers;
